import { useStyletron } from "baseui";
import { MdOutlineSensorDoor } from "react-icons/md";
import { LabelSmall, ParagraphXSmall } from "baseui/typography";
import { FormattedMessage } from "react-intl";
import { useGetMatchQuery } from "../../../services/objects";
import { modelId } from './types'
import { ValueDisplayWithLabel } from "../../components/ValueDisplay";
import { HorizontalStackPanel } from "../../../components/Layout/StackPanel";

const OpenDoorPanel = (props: { parentId: string, resourceGroupId: string }) => {
    const [, theme] = useStyletron();
    // api
    const { data: openDoors } = useGetMatchQuery({
        objectId: props.parentId,
        resourceGroupId: props.resourceGroupId,
        hops: '..4',
        relationship: 'Contains',
        modelId: modelId,
        queryParameters: 'IsOpen=true'
    });


    const openDoorsCnt = openDoors?.length ?? 0;

    return (
        <>
            {openDoorsCnt > 0 &&
                <HorizontalStackPanel>
                    <MdOutlineSensorDoor color={theme.colors.negative500} size='1.0em'/>
                    <ValueDisplayWithLabel label={""} small value={openDoorsCnt}></ValueDisplayWithLabel>
                    <ParagraphXSmall margin={0} color={theme.colors.primary500}>
                    {openDoorsCnt === 1 ?
                        <FormattedMessage id="Door.DoorOpen" defaultMessage="Door is open" />
                        :
                        <FormattedMessage id="Door.DoorsOpen" defaultMessage="Doors are open" />
                    }
                    </ParagraphXSmall>
                </HorizontalStackPanel>
            }
        </>
    )
}

export default OpenDoorPanel;